import { render } from "./appAdmin.vue?vue&type=template&id=d412493e"
import script from "./appAdmin.vue?vue&type=script&lang=js"
export * from "./appAdmin.vue?vue&type=script&lang=js"

import "./appAdmin.vue?vue&type=style&index=0&id=d412493e&lang=css"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__